import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputCheckbox } from '@components/input-checkbox';
import { SwitchToggle } from '@components/switch-toggle';
import classNames from 'classnames';

import {
  INPUT_CHECKBOX,
  INPUT_LEFT,
  INPUT_RIGHT,
  INPUT_TOOGLE,
  InputWithTitleAndSubtitleProps,
} from './input-with-title-and-subtitle.type';

export const InputWithTitleAndSubtitle = ({
  translations,
  controllerName,
  className = '',
  inputType,
  inputPosition = INPUT_RIGHT,
  textWidthClassname,
  disabled,
  checked,
}: InputWithTitleAndSubtitleProps) => {
  const { control } = useFormContext();
  const [isChecked, setIsChecked] = useState(checked);
  return (
    <div
      className={classNames(`flex text-left ${className}`, {
        'flex-row-reverse gap-3 pl-1 justify-end': inputPosition === INPUT_LEFT,
        'justify-between': inputPosition === INPUT_RIGHT,
        'items-center': inputType === INPUT_CHECKBOX,
      })}>
      <div
        className={classNames({
          'w-auto md:w-48 pr-2': !textWidthClassname,
          [`${textWidthClassname}`]: !!textWidthClassname,
        })}>
        <p
          className={classNames('text-primary', {
            'text-subtitle-s md:text-subtitle-m': checked,
            'text-body-s md:text-body-m': !checked,
          })}>
          {translations.title}
        </p>
        <p
          className={classNames('text-secondary', {
            'text-subtitle-xs md:text-subtitle-s': checked,
            'text-body-xs md:text-body-s': !checked,
          })}>
          {translations.subtitle}
        </p>
      </div>

      <Controller
        name={controllerName}
        control={control}
        render={({ field }) => (
          <>
            {inputType === INPUT_TOOGLE && (
              <SwitchToggle active={field.value} loading={false} onToggleSwitch={field.onChange} />
            )}
            {inputType === INPUT_CHECKBOX && (
              <InputCheckbox
                name={controllerName}
                value={field.value}
                disabled={disabled}
                checked={isChecked}
                onChange={(value) => {
                  setIsChecked(value);
                  field.onChange(value);
                }}
              />
            )}
          </>
        )}
      />
    </div>
  );
};
